import React, { useState, useEffect, useRef } from 'react';
import logo from '../../../assets/logo.svg';
import './LoadingScreenPage.css';

const LoadingScreenPage = ({ onFinish }) => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const requestRef = useRef();
  const startTimeRef = useRef();
  const duration = 5000; // 5s

  useEffect(() => {
    let mounted = true;

    function animate(time) {
      if (!startTimeRef.current) startTimeRef.current = time;
      const elapsed = time - startTimeRef.current;
      const percentage = Math.min((elapsed / duration) * 100, 100);

      if (mounted) setProgress(percentage);

      if (elapsed < duration) {
        requestRef.current = requestAnimationFrame(animate);
      } else if (mounted) {
        setTimeout(() => {
          if (mounted) {
            setIsVisible(false);
            if (onFinish) onFinish();
          }
        }, 1000);
      }
    }

    requestRef.current = requestAnimationFrame(animate);

    return () => {
      mounted = false;
      cancelAnimationFrame(requestRef.current);
    };
  }, [onFinish, duration]);

  return (
    <div
      className="loading-screen"
      style={{
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? 'auto' : 'none',
      }}
      aria-busy={isVisible}
      aria-live="polite"
      tabIndex={-1}
    >
      <div className="loading-content">
        <img src={logo} alt="Logo da empresa" />
        <div
          className="progress-bar"
          role="progressbar"
          aria-label="Carregando"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Math.round(progress)}
        >
          <div className="progress" style={{ width: `${progress}%` }} />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreenPage;
